import exchangeLogo from "@/assets/services/exchange.svg";
import heroLogo from "@/assets/services/hero.svg";
import studyhubLogo from "@/assets/services/studyhub.svg";

/**
 * Настоящие знаки сервисов — там, где они у нас есть.
 *
 * ── ПОЧЕМУ ФАЙЛ В РЕПОЗИТОРИИ, А НЕ ССЫЛКА ОТ СЕРВИСА ──────────────────────
 *
 * Экран входа — единственная страница, где бренд ЕСТЬ защита, и логотип,
 * принятый снаружи (параметром запроса или загрузкой через админку), ломает её
 * сразу двумя способами. ФИШИНГ: кто угодно, кто умеет собрать ссылку на
 * `authorize`, ставит ЛЮБОЙ бренд на НАШУ страницу входа — с настоящим доменом
 * и настоящим сертификатом, то есть всё, чему человека учат проверять,
 * сходится. XSS: SVG — это документ, а не картинка, он несёт `<script>` и
 * `onload`, и принять его значит принять код на страницу, где вводят код из
 * письма.
 *
 * Сервисов девять, добавляет их владелец, знак меняется раз в несколько лет —
 * при таких числах файл в репозитории строго лучше: проходит ревью, попадает в
 * бандл и не может измениться в рантайме.
 *
 * Те же файлы лежат в `id-web/src/assets/services/`: приложения собираются
 * раздельно (свой Vite у каждого), и общий пакет ради трёх картинок означал бы
 * тащить ассеты через `packages/ui`, который отдаёт только код и стили.
 *
 * Рисуем через `<img src>`, а не инлайном: SVG, загруженный картинкой, скрипты
 * не исполняет в принципе, и `id` градиентов и масок внутри разных знаков не
 * сталкиваются между собой — а они там есть у каждого.
 */
const LOGOS: Readonly<Record<string, string>> = {
	// Exchange! носит ТОТ ЖЕ знак ЦМО, что и сам единый профиль: у Портала и
	// IEC ID общий бренд, а не два разных логотипа.
	exchange: exchangeLogo,
	hero: heroLogo,
	studyhub: studyhubLogo,
};

/** Адрес знака сервиса или `undefined` — тогда рисуется глиф из реестра. */
export function serviceLogoSrc(serviceId: string | null | undefined): string | undefined {
	return serviceId ? LOGOS[serviceId] : undefined;
}
